/**
 * Income tax advance (מקדמות מס הכנסה) for one period.
 * `total` is the advance before withholding, `AcceptedWithholdingTaxMaximum` is the withholding
 * that can be offset (capped at the advance), `IncomeTaxAdvances` is what is left to pay.
 *
 * With `allowNegative`, a negative advance (negative turnover) stays negative instead of being
 * floored at zero: withholding only offsets the positive part of the advance, and a negative
 * withholding (a correction) is taken as is.
 */
export const calculateIncomeTaxAdvances = (
    incomesNoVat,
    acceptedWithholdingTax,
    incomeTaxAdvancePercentage,
    useIncomeTaxAdvancePercentage,
    IncomeTaxAdvanceAmount,
    surplusExpenses = 0,
    { allowNegative = false } = {}
) => {
    let total = (incomesNoVat * (incomeTaxAdvancePercentage / 100)) || 0;
    if (!useIncomeTaxAdvancePercentage) {
        total = IncomeTaxAdvanceAmount;
    }

    if (allowNegative) {
        total = Number(total) || 0;
        const withholding = Number(acceptedWithholdingTax) || 0;
        const AcceptedWithholdingTaxMaximum = Math.min(withholding, Math.max(total, 0));
        const IncomeTaxAdvances = total - AcceptedWithholdingTaxMaximum + (Number(surplusExpenses) || 0);
        return { IncomeTaxAdvances, AcceptedWithholdingTaxMaximum, total };
    }

    let IncomeTaxAdvances = (total - acceptedWithholdingTax) || 0;
    if (IncomeTaxAdvances < 0) {
        IncomeTaxAdvances = 0;
    }
    let AcceptedWithholdingTaxMaximum = acceptedWithholdingTax;
    if (acceptedWithholdingTax > total) {
        AcceptedWithholdingTaxMaximum = total;
    }

    IncomeTaxAdvances += surplusExpenses;
    return { IncomeTaxAdvances, AcceptedWithholdingTaxMaximum, total };
};

export default calculateIncomeTaxAdvances;
